export default __webpack_public_path__ + "static/media/coinbaseWallet.ae86a337.png";